// API returns a bare array, not an object with "interactions" key
type FeatureInteractionData = Array<{ features: string[]; mi_score: number }>;

interface FeatureInteractionVizProps {
  data: FeatureInteractionData;
}

export function FeatureInteractionViz({ data }: FeatureInteractionVizProps) {
  if (!data || !Array.isArray(data) || data.length === 0) {
    return <p className="text-xs text-muted">No feature interaction data available.</p>;
  }

  return (
    <div>
      <h3 className="mb-3 font-mono text-sm font-semibold text-navy-600 dark:text-zinc-300">
        Feature Interactions (Mutual Information)
      </h3>
      <div className="overflow-hidden rounded-lg border border-line">
        <table className="w-full">
          <thead className="bg-surface">
            <tr>
              <th className="px-3 py-2 text-left font-mono text-[10px] font-semibold uppercase tracking-wider text-navy-300">
                Features
              </th>
              <th className="px-3 py-2 text-right font-mono text-[10px] font-semibold uppercase tracking-wider text-navy-300">
                MI Score
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-line">
            {data.map((interaction, idx) => (
              <tr
                key={`${interaction.features.join("-")}-${idx}`}
                className="bg-surface hover:bg-surface-hover"
              >
                <td className="px-3 py-2 font-mono text-sm text-navy-700 dark:text-zinc-200">
                  {interaction.features.join(" × ")}
                </td>
                <td className="px-3 py-2 font-mono tabular-nums text-sm text-navy-700 dark:text-zinc-200 text-right">
                  {interaction.mi_score.toFixed(4)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
